import { useState, useEffect, useCallback } from 'react';
import {
  createAvoirAchat,
  saveAvoirAchat,
  getAvoirAchat,
  listAvoirsAchat,
  getItemsInAvoirAchat,
  validateAvoirAchat,
  unvalidateAvoirAchat,
} from '../models/achatAvoirAPI';

export const useFetchAllAvoirsAchat = (params) => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const fetchData = useCallback(async () => {
    try { setLoading(true); const res = await listAvoirsAchat(params); setItems(res.data.items || []); setTotal(res.data.total || 0); }
    catch (e) { setError(e.message); }
    finally { setLoading(false); }
  }, [params]);
  useEffect(() => { fetchData(); }, [fetchData]);
  return { items, total, loading, error, refetch: fetchData };
};

export const useFetchAvoirAchatById = (id) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const fetchOne = useCallback(async () => {
    if (!id) return;
    try { setLoading(true); const res = await getAvoirAchat(id); setData(res.data); }
    catch (e) { setError(e.message); }
    finally { setLoading(false); }
  }, [id]);
  useEffect(() => { fetchOne(); }, [fetchOne]);
  return { data, loading, error, refetch: fetchOne };
};

export const useFetchItemsInAvoirAchat = (id) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const fetchItems = useCallback(async () => {
    if (!id) return;
    try { setLoading(true); const res = await getItemsInAvoirAchat(id); setItems(res.data || []); }
    catch (e) { setError(e.message); }
    finally { setLoading(false); }
  }, [id]);
  useEffect(() => { fetchItems(); }, [fetchItems]);
  return { items, loading, error, refetch: fetchItems };
};

export const useCreateAvoirAchat = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const create = async (payload) => {
    try { setLoading(true); const res = await createAvoirAchat(payload); return res.data; }
    catch (e) { setError(e.message); throw e; }
    finally { setLoading(false); }
  };
  return { create, loading, error };
};

export const useSaveAvoirAchat = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const save = async (avoir, details) => {
    try { setLoading(true); const res = await saveAvoirAchat({ avoir, details }); return res.data; }
    catch (e) { setError(e.message); throw e; }
    finally { setLoading(false); }
  };
  return { save, loading, error };
};

export const useValidateAvoirAchat = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const validate = async (id) => {
    try { setLoading(true); const res = await validateAvoirAchat(id); return res.data; }
    catch (e) { setError(e.message); throw e; }
    finally { setLoading(false); }
  };
  return { validate, loading, error };
};

export const useUnvalidateAvoirAchat = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const unvalidate = async (id) => {
    try { setLoading(true); const res = await unvalidateAvoirAchat(id); return res.data; }
    catch (e) { setError(e.message); throw e; }
    finally { setLoading(false); }
  };
  return { unvalidate, loading, error };
};

